const ARRIVAL = "Arrival"
const DEPARTURE = "Departure"

export const SchedulesAddDetailRow = {
  ARRIVAL,
  DEPARTURE,
}
